import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import {Link} from 'react-router-dom';
import VideoPopup from './../components/VideoPopup'

//images
import bg2 from './../assets/images/background/bg2.png';
import logowhite from './../assets/images/logo-white.png';

function Footer(){
	const form = useRef();
	const sendEmail = (e) => {
		e.preventDefault();
		//emailjs.sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', form.current, 'YOUR_USER_ID')
		emailjs.sendForm('gmail', 'YOUR_TEMPLATE_ID', e.target, 'd9b2e0f5fc72cb94792110e8ff2028f3-us16')
		  .then((result) => {
			  console.log(result.text);
		  }, (error) => {
			  console.log(error.text);
		  });
		  e.target.reset()
	 };	
	return(
		<>
			<footer className="site-footer style-2" id="footer">
				<div className="footer-top" style={{backgroundImage:"url(" +  bg2 + ")"}}>
					<div className="container">
						<div className="row m-b40 m-md-b10">
							<div className="col-xl-3 col-lg-3 col-sm-6 aos-item" data-aos="fade-up" data-aos-duration="800" data-aos-delay="200">
								<div className="widget widget_about">
									<div className="footer-logo logo-white">
										<Link to={"./"}><img src={logowhite} alt="" /></Link> 
									</div>
									<p>Uchange4better’s energy services provided in conjunction with our affiliates to managing your gas and electric supplies in these challenging times and also to meet other monitoring and compliance requirements where appropriate.</p>
								</div>
							</div>
							<div className="col-xl-3 col-lg-3 col-sm-6 aos-item" data-aos="fade-up" data-aos-duration="800" data-aos-delay="400">
								<div className="widget">
									<h4 className="footer-title">Quick Contact</h4>
									<p>Managing your gas, electric supplies and comprehensive package of broadband, voice, and mobile
communications</p>
									<div className="call-box2 m-b20"><span><i className="fas fa-phone"></i></span>01492 87107</div>
								</div>
							</div>
							<div className="col-xl-2 col-lg-2 col-sm-4 aos-item" data-aos="fade-up" data-aos-duration="800" data-aos-delay="600">
								<div className="widget widget_services">
									<h4 className="footer-title">Our site</h4>
									<ul>
										<li><Link to={"./"}>Home</Link></li>
										<li><Link to={"./services"}>Services</Link></li>
									</ul>
								</div>
							</div>
						</div>
						<div className="footer-info aos-item" data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100">
							<div className="row">
								<div className="col-lg-4">
									<div className="dz-media">

									</div>
								</div>
								<div className="col-lg-8">
									<div className="info-right">
										<ul className="service-info">
											<li>
												<h5 className="title">Email Us</h5>
												<p>martin.edwards@uchange4better.co.uk</p>
											</li>

										</ul>
									</div>
								</div>
							</div>
						</div>
						
					</div>
				</div>
				{/*  footer bottom part  */}
				<div className="footer-bottom">
					<div className="container">
						<div className="row align-items-center">
							<div className="col-lg-12 text-center"> 
								<span className="copyright-text">Copyright © 2023 <a href="https://www.uchange4better.co.uk/" target="_blank" className="text-primary" rel="noreferrer">UChange4better</a>. All rights reserved.</span>
							</div>
						</div>
					</div>
				</div>
			</footer>
		</>
	)
}
export default Footer;